import _Logout from "./_logout";
import _Course from "./_course";
import _Courses from "./_courses";
import _CreateCourse from "./_create-course";

export const Logout = _Logout;
export const Course = _Course;
export const Courses = _Courses;
export const CreateCourse = _CreateCourse;
